import { integer, readSearch, text } from '@/lib/search-params'

export const AUDIT_PAGE_SIZE = 50

/**
 * Filtres du journal, portés par l'URL : une recherche se partage et survit au
 * rechargement.
 */
const SHAPE = {
  client: text(),
  acteur: text(),
  /** Types d'évènement séparés par des virgules ; un type inconnu vaut 422. */
  types: text(),
  du: text(),
  au: text(),
  page: integer({ min: 1 }),
}

export interface AuditSearch {
  client?: string | undefined
  acteur?: string | undefined
  types?: string | undefined
  du?: string | undefined
  au?: string | undefined
  page?: number | undefined
}

export function parseAuditSearch(search: Record<string, unknown>): AuditSearch {
  return readSearch(SHAPE, search)
}

export function hasActiveAuditFilters(search: AuditSearch): boolean {
  return !!(search.client ?? search.acteur ?? search.types ?? search.du ?? search.au)
}

export const EMPTY_AUDIT_FILTERS = {
  client: undefined,
  acteur: undefined,
  types: undefined,
  du: undefined,
  au: undefined,
  page: undefined,
} satisfies AuditSearch
